import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  noSites: 'No Sites yet',
  noSitesDescription: 'Once Sites have been created, they will appear here',
  noResult: 'No results found',
  noResultDescription: 'Please check your search query and try again.',
})
